import { useEffect, useState } from "react";
import { Footer } from "../../components/Footer";
import { FancyButton } from "./components/button";
import { VerticalLine } from "./components/lines";
import { FlexContainer, MainContainer } from "./components/mainContainer";
import { CoverRestaurant } from "./cover";
import { Filosofy } from "./filosofy";
import { FoodGallery } from "./foodGallery";
import { ImgScroll } from "./imgscroll";
import { Location } from "./location";
import { NewsLetter } from "./newsletter";
import { Offerta } from "./offerta";
import { Sponsors } from "./sponsors";
import styled from "styled-components";
import { useTraduzioniQuery } from "../../generated/graphql";
const PrenotaCointainer = styled.div`
  width: 100%;
  padding: 50px 50px;
  box-sizing: border-box;
  @media (max-width: 900px) {
    padding: 50px 0px;
  }
`;
export function adatta(evt: { data: string }) {
  var offsetH = 0;
  if (false) {
  } else {
    var iFrameID = document.getElementById("iFramePrenota");
    if (iFrameID) {
      iFrameID.style.border = "0";
      iFrameID.style.width = "100%";
      iFrameID.style.marginBottom = "1500px";
      var myHeight = evt.data.toString();
      if (evt.data == "top") {
        var mytop =
          iFrameID.getBoundingClientRect().top +
          window.pageYOffset -
          iFrameID.ownerDocument.documentElement.clientTop -
          offsetH;
        document.documentElement.scrollTop = mytop;
        iFrameID.style.marginBottom = "0";
      } else if (myHeight.substring(0, 6) == "middle") {
        var mytop =
          iFrameID.getBoundingClientRect().top +
          window.pageYOffset -
          iFrameID.ownerDocument.documentElement.clientTop -
          offsetH;
        iFrameID.style.height = window.innerHeight + "px";
        iFrameID.style.marginBottom = "0";
        window.scrollTo(0, mytop);
      } else {
        iFrameID.style.height = evt.data + "px";
        iFrameID.style.marginBottom = "0";
      }
    }
  }
}

export function Restaurant() {
  const [isPrenota, setPrenota] = useState<"ristorante" | "bistrot" | boolean>(
    false
  );
  useEffect(() => {
    if (window.addEventListener) {
      // For standards-compliant web browsers
      window.addEventListener("message", adatta, false);
    }
  });

  function scrollPrenota() {
    var bookId = document.getElementById("book");
    if (bookId) {
      var mytop =
        bookId.getBoundingClientRect().top -
        120 -
        bookId.ownerDocument.documentElement.clientTop;
      document.documentElement.scrollTop = mytop;
      setPrenota("ristorante");
    }
  }
  const lang = localStorage.getItem("lang") || "it";
  const { data } = useTraduzioniQuery();

  return (
    <>
      <CoverRestaurant book={scrollPrenota} />
      <FlexContainer>
        <MainContainer>
          <VerticalLine height="70px"></VerticalLine>
          <Filosofy />
          <VerticalLine height="100px" />
          <ImgScroll />
          <Location />
          <Offerta />
          <FancyButton onClick={() => setPrenota("ristorante")} id="book">
            {data?.traduzioniVarie?.prenota}
          </FancyButton>
          <PrenotaCointainer>
            {isPrenota && (
              <iframe
                title="Prenota"
                src={
                  `https://thepadelresort.prenota-web.it/prenotazioni/?iframe=1&lang=${lang}` +
                  (isPrenota === "ristorante" ? "" : "&ristorante=bistrot")
                }
                allowFullScreen
                style={{ border: "none", width: "100%", height: "1000px" }}
                id="iFramePrenota"
              ></iframe>
            )}
          </PrenotaCointainer>
          <FoodGallery />
          <NewsLetter />
        </MainContainer>
      </FlexContainer>
      <Sponsors />
      <Footer
        number="+390318180880"
        email="kumrestaurant@thepadelresort.it"
        prettyNumber="+39 031 8180 880"
      />
    </>
  );
}
